import { render, staticRenderFns } from "./FooterView2.vue?vue&type=template&id=3b390400&scoped=true&"
import script from "./FooterView2.vue?vue&type=script&lang=js&"
export * from "./FooterView2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b390400",
  null
  
)

export default component.exports